import { useMemo } from 'react'
import { HugeiconsIcon } from '@hugeicons/react'
import { PencilEdit01Icon } from '@hugeicons/core-solid-rounded'
import { useQuery } from '@apollo/client/react'
import { AdminAPI, getFragment, GraphQL, SharedAPI } from '@guestgoodie/graphql'
import { dateTime } from '@guestgoodie/helpers'
import { Link } from 'wouter'

import { rangeToText } from '../utils/time'
import { Trans } from '@lingui/react/macro'

interface EventOccurenceTileProps {
  event: GraphQL.EventOccurenceFragmentFragment
}

export default function EventOccurenceTile(props: EventOccurenceTileProps) {
  const { event } = props

  const { data } = useQuery(AdminAPI.goodie.GET, {
    variables: { id: event.goodieId }
  })

  const goodie = useMemo(
    () => getFragment(SharedAPI.goodie.GOODIE_FRAGMENT, data?.getGoodie),
    [data]
  )

  const time = useMemo(() => {
    const start = new Date(event.startAt)
    const end = new Date(event.endAt)

    return rangeToText(
      event.startAt,
      end.getTime() - start.getTime(),
      dateTime.timeFormatter
    )
  }, [event.startAt, event.endAt])

  return (
    <Link
      className="flex flex-row items-center gap-4 rounded bg-white p-5 cursor-pointer"
      to={`/edit-event-occurence/${event.token}`}
    >
      <div className="flex flex-col py-2.5">
        <span className="text-heading2 text-text">
          {event.seatsTaken}
          {event.maxSeats ? `/${event.maxSeats}` : ''}
        </span>
        <span className="text-small text-text-light">
          <Trans>Participant</Trans>
        </span>
      </div>
      <div className="h-full w-px bg-text-light" />
      <div className="flex flex-1 items-start justify-start flex-col gap-1">
        <h3 className="text-heading3 text-text text-left">{goodie?.title}</h3>
        <span className="text-heading3 text-text-light">{time}</span>
      </div>
      <div className="flex h-full flex-row items-center pr-2">
        <HugeiconsIcon icon={PencilEdit01Icon} className="size-6" />
      </div>
    </Link>
  )
}
